export const apiConfig = {
  apiClientScope:
    window.env?.AZUREAD_MSAL_SCOPE ?? process.env.REACT_APP_MSAL_SCOPE,
}
